import { z } from 'zod'
import { textoObrigatorio } from './comum'

/**
 * Biblioteca de materiais: o acervo de venda que o proprietário monta e a
 * equipe manda para o cliente sem sair da conversa.
 *
 * O que entra é o que o vendedor precisa ter à mão na hora de responder:
 * fotos, vídeos e PDFs de guia. Planilha, .docx e .zip ficam de
 * fora de propósito — abrem uma biblioteca de arquivo qualquer, que ninguém
 * consegue manter organizada, e nenhum deles tem prévia para conferir antes
 * de mandar.
 */
export const MIMES_DE_MATERIAL = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'video/mp4',
  'video/webm',
  'video/quicktime',
  'application/pdf',
] as const

export type TipoMaterial = 'imagem' | 'video' | 'documento'

export function materialAceito(mime: string | null | undefined): boolean {
  const limpo = (mime ?? '').split(';')[0]?.trim().toLowerCase() ?? ''
  return (MIMES_DE_MATERIAL as readonly string[]).includes(limpo)
}

export function tipoDoMaterial(mime: string): TipoMaterial {
  const limpo = mime.split(';')[0]?.trim().toLowerCase() ?? ''
  if (limpo.startsWith('image/')) return 'imagem'
  if (limpo.startsWith('video/')) return 'video'
  return 'documento'
}

export const criarPastaMaterialSchema = z.object({
  nome: textoObrigatorio('nome da pasta', 80),
})

export const atualizarPastaMaterialSchema = z.object({
  nome: textoObrigatorio('nome da pasta', 80).optional(),
  ordem: z.number().int().min(0).max(999).optional(),
})
export type AtualizarPastaMaterialEntrada = z.infer<typeof atualizarPastaMaterialSchema>

/** Rota de envio: o chamado e o material vêm na URL. */
export const enviarMaterialSchema = z.object({
  id: z.string().uuid('chamado inválido'),
  materialId: z.string().uuid('material inválido'),
})

export const atualizarMaterialSchema = z.object({
  nome: textoObrigatorio('nome do material', 160).optional(),
  descricao: z.string().trim().max(300).nullable().optional(),
  pastaId: z.string().uuid().optional(),
  ordem: z.number().int().min(0).max(999).optional(),
})
export type AtualizarMaterialEntrada = z.infer<typeof atualizarMaterialSchema>

export interface MaterialDto {
  id: string
  pastaId: string
  nome: string
  descricao: string | null
  mime: string
  tipo: TipoMaterial
  tamanho: number
  nomeArquivo: string
  /** Caminho servido pela API. `?baixar=1` força salvar no computador. */
  arquivoUrl: string
  criadoEm: string
  enviadoPorNome: string | null
}

export interface PastaMaterialDto {
  id: string
  nome: string
  ordem: number
  materiais: MaterialDto[]
}
